/*
 * @Author: qianyl
 * @Descripttion:
 * @Date: 2023-10-10 10:51:00
 * @LastEditors: codesides
 * @LastEditTime: 2026-04-22 17:05:39
 * @FilePath: \lesson-web-cms\src\api\common.ts
 */
import axios from "@/axios/index";
import { get, post, _post } from "@/utils/requestKhfw";
import { HOME_PREFIX } from "@/utils/config";
type APIParams = {
  schoolId: string;
};
enum isDefaultEnum {
  NO = "NO",
  YES = "YES",
}
export type LessonSpecialtyNameDTO = {
  childList: LessonSpecialtyNameDTO[];
  id: string | number;
  isDefault: isDefaultEnum;
  parentId: string | number;
  title: string;
};

export type yearSemesterReturn = {
  name: string;
  value: string;
  current: Boolean;
};
// 查询专业分类信息
export const fetchSpecialtyList = (params: APIParams) => {
  return axios.get<LessonSpecialtyNameDTO[]>("/area/common/specialty/list.do", {
    params,
  });
};

// 学年学期
export const fetchYearSemester = () => {
  return axios.get<Array<yearSemesterReturn>>("/common/term.do");
};

export type schoolResult = {
  code: string; // 学校ID
  value: string; // 学校名称
  regionCode: string; // 行政区划CODE
};
// 教育局获取学校查询列表
export const fetchSchoolData = (params: any) => {
  return axios.get<Array<schoolResult>>("/area/common/school/list.do", {
    params,
  });
};
// 教育局获取学校查询列表
export const fetchGradeData = (params: { schoolId: string }) => {
  return axios.get("/area/common/grade/sort/list.do", { params });
};

// 获取登录信息
export const getUserInfo = () => {
  return axios.get(HOME_PREFIX + "/common/getLoginUserInfo");
};
// 获取domain
export const getDomains = () => {
  return axios.get(HOME_PREFIX + "/common/getSystemDomains.do");
};
// 获取标头
export const getCommon = () => {
  return axios.get("/common/getLoginUser.do");
};

// 获取区域
export const getRegion = (params = {}) => {
  return axios.get("/region/list.do", { params });
};

// 获取权限
export const getPermission = () => {
  return axios.get(HOME_PREFIX + "/common/get-permission-info.do");
};

// 获取学校的学段年级
export const getSchoolCourseSort = (params = {}) => {
  return axios.get("/area/common/courseSortList.do", { params });
};
// 课程分类
export const getLessonTemplateType = (params = {}) => {
  return axios.get("/teacher/getLessonTemplateType.do", params);
};

// 获取可切换的账号列表
export const getAccountList = (params) => {
  return axios.get(HOME_PREFIX + "/account/getAccountList.do", params);
};

// 获取切换账号单点url
export const getAccountUrl = (params) => {
  return axios.post(HOME_PREFIX + "/account/ssoUrl.do", params);
};

// 获取学年学期
export const getSchoolTermList = () => {
  return get("/khfw/base/school-term/list");
};

// 测试限流接口-1分钟内最多点击10次
export const getTestClick = () => {
  return axios.post(HOME_PREFIX + "/system/rateLimit/testClick");
};

// 导出-校验权限
export const getExportCheck = () => {
  return axios.get(HOME_PREFIX + "/system/export/check")
}

// 登录-发送短信验证码
export const getSMSCode = () => {
  return axios.get(HOME_PREFIX + "/login/sms/sendVerifyCodeForExport")
}

// 导出-校验短信验证码
export const getExportSMSCode = (code) => {
  return axios.get(HOME_PREFIX + `/system/export/verifyExportSmsCode?code=${code}`)
}